export default {
  baseURL: process.env.REACT_APP_BASE_URL,
  authBaseURL: process.env.REACT_APP_AUTH_BASE_URL,
  inStationGrantPermissionURL: process.env.REACT_APP_INSTATION_GRANT_PERMISSIONS_URL,
  inStationStoreURL: process.env.REACT_APP_INSTATION_STORE_URL,
};
